import { Box, Typography, useMediaQuery, Menu, MenuItem } from '@mui/material';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { useHasPermission } from '../../../hooks/useHasPermission';
import { UpdateRegion } from '../editRegion/updateRegion';
import { DeleteRecord } from '../../deleteRecord';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useListBackNavigation } from '../../../hooks/listNavigation';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import Iconify from '../../Iconify';
import axios from 'axios';
import '../../../css/roles/roleDetailsHeader.css';

const RegionDetailsHeader = () => {

    const { t } = useTranslation();
    const { goBack, goToList } = useListBackNavigation('/dashboard/regions');
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    const regionDetailsData = useSelector((state) => state?.RegionDetailsData);

    const hasRegionUpdatePermission = useHasPermission('region_update');
    const hasRegionDeletePermission = useHasPermission('region_delete');

    const [errMsg, setErrMsg] = useState('');
    const [updateRegionOpen, setUpdateRegionOpen] = useState(false);
    const [deleteRegionOpen, setDeleteRegionOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const openActionMenu = Boolean(anchorEl);

    const handleDeleteRegion = async () => {
        try {
            const response = await axios.delete(`region/${regionDetailsData.id}`);
            if (response.status === 200 || response.status === 201) {
                setDeleteRegionOpen(false);
                goToList();
                setErrMsg('');
            }
        } catch (error) {
            setErrMsg(error.message || "Erreur lors de la suppression de la region");
            console.error('Error deleting region:', error);
            CustomErrorLogger(error, "Delete region");
        }
    }

    const handleOpenActionMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseActionMenu = () => {
        setAnchorEl(null);
    };

    const handleGoBack = goBack;

    return (
        <Box className="roleDetailsHeader_mainBox">
            <Box className="roleDetailsHeader_firstPart">
                <Iconify className='roleDetailsHeader_back_icon' icon={"material-symbols:arrow-back"} onClick={handleGoBack} />
                <Typography className="roleDetailsHeader_title">{regionDetailsData?.name}</Typography>
                {hasRegionUpdatePermission && <Iconify className='roleDetailsHeader_edit_icon' icon={"ic:outline-edit"} onClick={() => setUpdateRegionOpen(true)} />}
                {regionDetailsData?.description}
            </Box>
            <Box className="roleDetailsHeader_secondPart">
                {isDesktop && hasRegionDeletePermission &&
                    <Box className="roleDetailsHeader_action_box" onClick={() => setDeleteRegionOpen(true)}>
                        <Iconify className='roleDetailsHeader_delete_icon' icon={"ic:outline-delete"} />
                        <Typography className="roleDetailsHeader_delete_title">{t('Supprimer')}</Typography>
                    </Box>
                }
                {!isDesktop && <Iconify
                    className='roleDetailsHeader_dots_icon'
                    icon={"vaadin:ellipsis-dots-v"}
                    id="userPageActionMenuIcom"
                    aria-controls={openActionMenu ? 'long-menu' : undefined}
                    aria-expanded={openActionMenu ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleOpenActionMenu}
                />}
                <Menu
                    id="usersePageActionMenu"
                    MenuListProps="usersPageActionMenuIcom"
                    open={openActionMenu}
                    anchorEl={anchorEl}
                    onClose={handleCloseActionMenu}
                    onClick={handleCloseActionMenu}
                    slotProps={{ paper: { style: { width: '30ch', backgroundColor: '#fffff' } } }}
                >
                    {!isDesktop && hasRegionDeletePermission &&
                        <MenuItem className='roleDetailsHeader_menuItem' onClick={() => setDeleteRegionOpen(true)}>
                            <Iconify className='roleDetailsHeader_delete_icon' icon={"ic:outline-delete"} />
                            <Typography className="roleDetailsHeader_delete_title">{t('Supprimer')}</Typography>
                        </MenuItem>
                    }
                </Menu>
            </Box>

            {updateRegionOpen &&
                <UpdateRegion
                    updateRegionOpen={updateRegionOpen}
                    setUpdateRegionOpen={setUpdateRegionOpen}
                />
            }

            {deleteRegionOpen &&
                <DeleteRecord
                    errMsg={errMsg}
                    setErrMsg={setErrMsg}
                    openDelete={deleteRegionOpen}
                    setOpenDelete={setDeleteRegionOpen}
                    handleDelete={handleDeleteRegion}
                    title="Êtes-vous sûr de vouloir supprimer cette region ?"
                />
            }
        </Box>
    );
}

export default RegionDetailsHeader;